import request from "@utils/request";
import { VUE_APP_API_URL } from "@/utils/index";

export function login(data) {
  return request.post("/login", data, {
    login: false
  });
}

export function loginMobile(data) {
  return request.post("/login/mobile", data, {
    login: false
  });
}

export function registerVerify(data) {
  return request.post("/register/verify", data, {
    login: false
  });
}

export function register(data) {
  return request.post("/register", data, {
    login: false
  });
}

export function getCoupon(q) {
  return request.get("/coupons", q, {
    login: true
  });
}

export function getCouponReceive(id) {
  return request.post("/coupon/receive", {
    couponId: id
  }, {
    login: true
  });
}

export function couponReceiveBatch(couponId) {
  return request.post("/coupon/receive/batch", {
    couponId
  });
}

export function getCouponsUser(type) {
  return request.get("/coupons/user/" + type);
}

export function getUser() {
  return request.get("/user");
}

export function getUserInfo() {
  return request.get("/userinfo", {
    login: true
  });
}

export function getMenuUser() {
  return request.get("/menu/user");
}

export function getAddressList(data) {
  return request.get("/address/list", data || {});
}

export function getAddressRemove(id) {
  return request.post("/address/del", {
    id: id
  });
}

export function getAddressDefaultSet(id) {
  return request.post("/address/default/set", {
    id: id
  });
}

export function getAddressDefault() {
  return request.get("/address/default");
}

export function getAddress(id) {
  return request.get("/address/detail/" + id);
}

export function postAddress(data) {
  return request.post("/address/edit", data);
}

export function getCollectUser(page, limit, type) {
  return request.get("/collect/user", {
    page: page,
    limit: limit,
    type: type
  });
}

export function getCollectDel(id, category) {
  return request.post("/collect/del", {
    id: id,
    category: category
  });
}

export function getCollectAdd(id, category) {
  return request.post("collect/add", {
    id: id,
    category: category
  });
}

export function getSignConfig() {
  return request.get("/sign/config");
}

export function getSignList(page, limit) {
  return request.get("/sign/list", {
    page: page,
    limit: limit
  });
}

export function getSignMonth(page, limit) {
  return request.get("/sign/month", {
    page: page,
    limit: limit
  });
}

export function postSignUser(sign) {
  return request.post("/sign/user", sign);
}

export function postSignIntegral(sign) {
  return request.post("/sign/integral", sign);
}

export function getSpreadInfo() {
  return request.get("/commission");
}

export function getSpreadUser(screen) {
  return request.post("/spread/people", screen);
}

export function getSpreadOrder(where) {
  return request.post("/spread/order", where);
}

export function getCommissionInfo(q, types) {
  return request.get("/spread/commission/" + types, q);
}

export function getIntegralList(q) {
  return request.get("/integral/list", q);
}

export function getBank() {
  return request.get("/extract/bank");
}

export function postCashInfo(cash) {
  return request.post("/extract/cash", cash);
}

export function getVipInfo() {
  return request.get("/user/level/grade");
}

export function getVipTask(id) {
  return request.get("/user/level/task/" + id);
}

export function getBalance() {
  return request.get("/user/balance");
}

export function getSpreadImg(data) {
  return request.get("/spread/banner", data);
}

export function postUserEdit(data) {
  return request.post("/user/edit", data);
}

export function rechargeWechat(data) {
  return request.post("/recharge/wechat", data);
}

export function getLogout() {
  return request.post("/auth/logout");
}

export function bindingPhone(data) {
  return request.post("binding", data);
}

export function setDetection() {
  return request.get("user/level/detection");
}

export function getRechargeApi() {
  return request.get("recharge/index");
}

export function getCity() {
  return request.get("/city_list", {}, {
    login: false
  });
}
// 教练注册
export function coachRegister(data) {
  return request.post("/coachRegister", data, {
    login: false
  });
}
//基本信息修改
export function coachSave(data) {
  return request.post("/product/addOrSave", data, {
    login: true
  });
}
//教练基本信息
export function coachInfo() {
  return request.get("/product/getOwnInfo", {}, {
    login: false
  });
}
//教练认证信息
export function coachExtendInfo() {
  return request.get("/extendInfo/detail", {}, {
    login: false
  });
}
//认证信息修改
export function coachExtendUpdate(data) {
  return request.post("/extendInfo/sumbit", data, {
    login: true
  });
}
//认证信息修改
export function userEdit(data) {
  return request.post("/user/edit", data, {
    login: true
  });
}

//忘记密码
export function passForget(data) {
  return request.post("/resetPassword", data, {
    login: false
  });
}

//校验手机号
export function checkPhone(data) {
  return request.post("/checkPhone", data, {
    login: false
  });
}



//获取自己的评价
export function getMyCommentList(params) {
  return request.get("/user/comment", params, {
    login: false
  });
}

// 获取验证码
export function coachRegisterCode(data) {
  return request.post("coachRegisterCode", data, {
    login: false
  });
}

// 教练入驻获取验证码
export function bindUserSms(data) {
  return request.post("bindUserSms", data, {
    login: true
  });
}

// 获取会员套餐列表
export function comboMemberList() {
  return request.get('combo/list', {}, {
    login: false
  })
}

// 获取推广参数
export function getRecordInfo(id) {
  return request.get("/getRecordInfo/" + id, {}, {
    login: true
  })
}

// 用户签约
export function recruitOne(data) {
  return request.post("/recruit/recruitOne", data, {
    login: true,
  });
}

// 用户解约
export function userUnbind(data) {
  return request.post("/recruit/recruitOne/unbind", data, {
    login: true,
  });
}

// 获取订单推广模板列表
export function getTemplateList() {
  return request.get("/getTemplateList", {}, {
    login: true
  });
}

// 生成订单推广模板
export function generateTemplateList(data) {
  return request.post("/generateTemplateList", data, {
    login: true
  });
}

// 根据Link获取数据
export function generateTemplateLink(data) {
  return request.post("/getTemplateByLink", data, {
    login: true
  });
}
//根据推广订单id删除
export function deleteTemplateById(id) {
  return request.post("/deleteTemplate", {
    id: id
  }, {
    login: true
  });
}
//获取签约合同
export function signFind() {
  return request.post("/recruit/signFind",{}, {
    login: true
  });
}

// PDF代理请求
export function getPdfProxy(url) {
  // 添加时间戳防止缓存
  const timestamp = new Date().getTime();
  return `${VUE_APP_API_URL}/api/pdf/proxy?url=${encodeURIComponent(url)}&t=${timestamp}`;
}